import Phaser from 'phaser'
import { gameConfig } from './config'

/**
 * Initialize and start the Phaser game
 */
export function createGame(): Phaser.Game {
  return new Phaser.Game(gameConfig)
}
